import { useEffect, useState } from 'react';

/**
 * 网络状态提示条
 * 监听 navigator.onLine + online/offline 事件；断网时从顶部滑入，
 * 恢复时延迟 800ms 消失避免闪烁。
 *
 * 注意：navigator.onLine 在桌面 Chrome 里有 bug（连着 Wi-Fi 但没外网仍返 true），
 * 所以真正"请求失败"的提示由 queryClient 全局 onError 负责；此组件只兜底浏览器
 * 能明确感知的断网状态。
 */
export default function OfflineBanner() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false
  );
  const [visible, setVisible] = useState(offline);

  useEffect(() => {
    const onOffline = () => {
      setOffline(true);
      setVisible(true);
    };
    const onOnline = () => {
      setOffline(false);
      // 恢复后短暂保留提示，让用户看到"已恢复"
      setTimeout(() => setVisible(false), 800);
    };
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  if (!visible) return null;

  const bg = offline
    ? 'linear-gradient(135deg, #E8745E, #D06049)'
    : 'linear-gradient(135deg, #6B9E6B, #5A8A5A)';

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[9999] text-white text-xs md:text-sm flex items-center justify-center gap-2 py-1.5"
      style={{
        background: bg,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        fontFamily: '"Noto Sans SC", system-ui, sans-serif',
      }}
    >
      <i
        className={offline ? 'ri-wifi-off-line' : 'ri-wifi-line'}
        aria-hidden
      ></i>
      <span>{offline ? '网络已断开，部分功能不可用' : '网络已恢复'}</span>
    </div>
  );
}
